import { CampaignType } from 'modules/domains/campaign/types';
import { ExperimentState } from 'modules/graphql';
import { BADGE_VARIANTS } from 'ui/badge';
import { BADGE_VARIANT_TYPES } from 'ui/badge/types';
import { BasePageExperimentData, ExperimentTableData } from '../types';

type BADGE_VARIANT_INFO = {
  variant: BADGE_VARIANT_TYPES;
  label: string;
};

export const mapStateToBadgeInfo = (state: ExperimentState): BADGE_VARIANT_INFO =>
  ({
    [ExperimentState.CANCELLED]: { variant: BADGE_VARIANTS.CANCELLED, label: 'Cancelled' },
    [ExperimentState.DRAFT]: { variant: BADGE_VARIANTS.DRAFT, label: 'Draft' },
    [ExperimentState.ERRORED]: { variant: BADGE_VARIANTS.ERRORED, label: 'Errored' },
    [ExperimentState.FINISHED]: { variant: BADGE_VARIANTS.FINISHED, label: 'Finished' },
    [ExperimentState.READY]: { variant: BADGE_VARIANTS.READY, label: 'Ready' },
    [ExperimentState.RUNNING]: { variant: BADGE_VARIANTS.RUNNING, label: 'Running' },
    [ExperimentState.SENDING_TO_REMAINDER]: { variant: BADGE_VARIANTS.RUNNING, label: 'Running' },
    [ExperimentState.USER_SELECTED_WINNER]: { variant: BADGE_VARIANTS.RUNNING, label: 'Running' },
    [ExperimentState.WINNER_FOUND]: { variant: BADGE_VARIANTS.WINNER_FOUND, label: 'Winner found' },
  })[state];

// covering the case where experiment is still winner_found
// but technically it should be finished
export const determineExperimentState = (
  experiment: ExperimentTableData | BasePageExperimentData,
) => {
  if (
    experiment.state === ExperimentState.WINNER_FOUND &&
    experiment.campaign.type === CampaignType.Blast &&
    experiment.evenlySplitVariations === false
  )
    return ExperimentState.FINISHED;
  return experiment.state;
};
